export const SET_ORGANIZATIONS = 'SET_ORGANIZATIONS';
export const SET_ORGANIZATIONS_FAILED = 'SET_ORGANIZATIONS_FAILED';
export const SET_LOADING = 'SET_LOADING';
export const GET_TOTALPAGES = 'GET_TOTALPAGES';
export const GET_TOTALPAGES_FAILED = 'GET_TOTALPAGES_FAILED';
export const GET_TOTALELMTS = 'GET_TOTALELMTS';
export const GET_TOTALELMTS_FAILED = 'GET_TOTALELMTS_FAILED';
export const SET_ALL_ORGANIZATIONS = 'SET_ALL_ORGANIZATIONS';
export const SET_ALL_ORGANIZATIONS_FAILED = 'SET_ALL_ORGANIZATIONS_FAILED';
export const SET_CURRENT_ORGA = 'SET_CURRENT_ORGA';
export const SET_CURRENT_ORGA_FAILED = 'SET_CURRENT_ORGA_FAILED';
export const LOAD_ERROR = 'LOAD_ERROR';
export const LOAD_STATS_SUCCESS = 'LOAD_STATS_SUCCESS';
export const SET_PATH = 'SET_PATH';
export const ADD_TO_PATH = 'ADD_TO_PATH';
export const SLICE_PATH = 'SLICE_PATH';
export const SPLICE_PATH = 'SPLICE_PATH';



// WEBPACK FOOTER //
// ./src/store/modules/organizations/types.js